import styled from "styled-components";

export const ImageShell = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const LoaderCenter = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  /* non-blocking: user can still interact elsewhere */
  pointer-events: none;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  opacity: ${({ $loaded }) => ($loaded ? 1 : 0)};
  transition: opacity 250ms ease;
`;
